<template>
  <div>
    <h1 class="title">Documentos</h1>
    <y-periodselector
      @period="periodselected"
      :iscierre="true"
      :period="period"
    ></y-periodselector>
    <div class="columns">
      <div class="column is-3">
        <div class="field">
          <label class="label">Comprobante</label>
          <div class="control">
            <div class="select">
              <select v-model="comprobante">
                <option
                  v-for="(item, index) in comprobantes"
                  :key="index"
                  :value="item._id"
                >
                  {{ item.codigo }} - {{ item.nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label has-text-white">.</label>
          <div class="control">
            <button class="button is-link" @click="searchDocs">Buscar</button>
          </div>
        </div>
      </div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Documento</th>
          <th class="has-text-right">Descuadre</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in documents" :key="index">
          <td>{{ item._id.documento }}</td>
          <td class="has-text-right fontMono">{{ item.valor | number(2) }}</td>
          <td>
            <button
              class="button is-danger is-small"
              @click="deleteDocument(item)"
            >
              <span class="icon is-small">
                <span class="material-icons"> delete_forever </span>
              </span>
            </button>
          </td>
          <table></table>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import yPeriodselector from "@/components/commons/PeriodselectorV2.vue";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
export default {
  data() {
    return {
      period: {
        year: null,
        months: null,
      },
      comprobantes: [],
      comprobante: null,
      documents: [],
    };
  },
  methods: {
    periodselected(period) {
      this.period = period;
    },
    async findComprobantes() {
      try {
        const result = await apiServices.get(`/comprobantes`);
        this.comprobantes = functions.order(result.data, "codigo");
      } catch (err) {
        console.log(err);
      }
    },
    async searchDocs() {
      try {
        const result = await apiServices.post(`/documentslist`, {
          period: this.period,
          comprobante: this.comprobante,
        });
        if (result.data) {
          this.documents = result.data;
          this.documents.sort((a, b) => {
            return a._id.documento < b._id.documento ? -1 : 1;
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteDocument(doc) {
      try {
        await apiServices.post(`/deletedocument`, {
          year: doc._id.year,
          mes: doc._id.mes,
          comprobante: doc._id.comprobanteid,
          documento: doc._id.documento,
        });
        this.searchDocs();
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.findComprobantes();
    const today = new Date();
    this.period.year = today.getFullYear();
    this.period.months = [today.getMonth() + 1];
  },
  components: {
    yPeriodselector,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/documents/Documents.vue